module.exports = __webpack_public_path__ + "static/media/avatar_3.208a87b0.jpg";